import { useEffect, useState } from 'react'

const STORAGE_KEY = 'todone.browse.inspirationColumns'
const DEFAULT_COLUMNS = 6
export const MIN_COLUMNS = 2
export const MAX_COLUMNS = 10

const readStoredColumns = (): number => {
  if (typeof window === 'undefined') return DEFAULT_COLUMNS
  const raw = window.localStorage.getItem(STORAGE_KEY)
  const parsed = raw ? Number(raw) : NaN
  if (!Number.isFinite(parsed)) return DEFAULT_COLUMNS
  return clamp(parsed)
}

const clamp = (n: number): number => Math.max(MIN_COLUMNS, Math.min(MAX_COLUMNS, Math.round(n)))

/**
 * Persisted column count for the Browse Inspiration grid. Used by the slider in the sticky
 * header and the grid's `gridTemplateColumns` calculation. Clamped to [{@link MIN_COLUMNS},
 * {@link MAX_COLUMNS}].
 */
export const useBrowseColumns = (): [number, (next: number) => void] => {
  const [columns, setColumns] = useState<number>(readStoredColumns)

  useEffect(() => {
    if (typeof window === 'undefined') return
    window.localStorage.setItem(STORAGE_KEY, String(columns))
  }, [columns])

  return [columns, (next) => setColumns(clamp(next))]
}
